var elementsForm,contLogin = 1;

function validationForm(elementsForm,contLogin)
{
    for(var i=0;i<elementsForm.length;i++){
        $('input[name='+elementsForm[i]+']').removeClass('error');
        if ( $.trim($("input[name="+elementsForm[i]+']').val()) == "" ) {
            contLogin = 0;
            $('input[name='+elementsForm[i]+']').addClass('error');
        }
    }
    return contLogin;
}

$('.submitEdit').click(function () {
    $('#formEdit').submit();
});

$('#formEdit').on('submit',function (e) {
    e.preventDefault();

    var data = $(this).serialize();

    var formData = new FormData();
    formData.append('rut_file', $('#formEdit input[name=rut_file]')[0].files[0]);
    formData.append('camera_file', $('#formEdit input[name=camera_file]')[0].files[0]);
    formData.append('document_file', $('#formEdit input[name=document_file]')[0].files[0]);
    //pay_1
    formData.append('payment_agreements_percent',$('#formEdit input[name=payment_agreements_percent]').val());
    formData.append('payment_agreements_value',$('#formEdit input[name=payment_agreements_value]').val());
    formData.append('payment_agreements_date',$('#formEdit input[name=payment_agreements_date]').val());
    formData.append('payment_agreements_pay',$('#formEdit input[name=payment_agreements_pay]').val());
    //pay_2
    formData.append('payment_agreements_percent_2',$('#formEdit input[name=payment_agreements_percent_2]').val());
    formData.append('payment_agreements_value_2',$('#formEdit input[name=payment_agreements_value_2]').val());
    formData.append('payment_agreements_date_2',$('#formEdit input[name=payment_agreements_date_2]').val());
    formData.append('payment_agreements_pay_2',$('#formEdit input[name=payment_agreements_pay_2]').val());
    //pay_3
    formData.append('payment_agreements_percent_3',$('#formEdit input[name=payment_agreements_percent_3]').val());
    formData.append('payment_agreements_value_3',$('#formEdit input[name=payment_agreements_value_3]').val());
    formData.append('payment_agreements_date_3',$('#formEdit input[name=payment_agreements_date_3]').val());
    formData.append('payment_agreements_pay_3',$('#formEdit input[name=payment_agreements_pay_3]').val());
    //pay_4
    formData.append('payment_agreements_percent_4',$('#formEdit input[name=payment_agreements_percent_4]').val());
    formData.append('payment_agreements_value_4',$('#formEdit input[name=payment_agreements_value_4]').val());
    formData.append('payment_agreements_date_4',$('#formEdit input[name=payment_agreements_date_4]').val());
    formData.append('payment_agreements_pay_4',$('#formEdit input[name=payment_agreements_pay_4]').val());

    
    formData.append('id_contract',$('#formEdit input[name=id_contract]').val());

    formData.append('active',$('#formEdit select[name=active]').val());

    swal({
        text: "Estamos validando, espere un momento ...",
        icon: imageURL,
        button: false,
        closeOnClickOutside: false,
    });

    $.ajax({
        url: https + "contractEdit",
        method: "POST",
        data: formData,
        processData: false,
        contentType: false,
        success: function (data) {
            if ($.trim(data) == "1") {
                //$("#formSignature")[0].reset();
                swal.close();
                swal({
                    text: "Contrato actualizado con exito!",
                    icon: imageURL,
                    button: "OK!",
                });
                setTimeout(function () {
                    location.reload();
                },1000);
            }else {
                swal({
                    text: "" + data,
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
});

let subtotal = 0,iva = 0,total = 0,iva_calculate = 0,value = 0;
let pay_1 = 0,pay_2=0,pay_3 = 0,pay_4=0;

$(document).ready(function () {
    if(window.location.href.replace(https,'').includes('edit')){
        setInterval(function(){
        
        subtotal = 0,iva = 0,total = 0,iva_calculate = 0,value = 0;
        pay_1 = 0,pay_2=0,pay_3 = 0,pay_4=0;
        
        if($('input[name=payment_agreements_percent]').val() != ""){
            pay_1 = parseFloat($('input[name=total]').val()) * parseFloat($('input[name=payment_agreements_percent]').val()) / 100;
        }
        if($('input[name=payment_agreements_percent_2]').val() != ""){
            pay_2 = parseFloat($('input[name=total]').val()) * parseFloat($('input[name=payment_agreements_percent_2]').val()) / 100;
        }
        if($('input[name=payment_agreements_percent_3]').val() != ""){
            pay_3 = parseFloat($('input[name=total]').val()) * parseFloat($('input[name=payment_agreements_percent_3]').val()) / 100;
        }
        if($('input[name=payment_agreements_percent_4]').val() != ""){
            pay_4 = parseFloat($('input[name=total]').val()) * parseFloat($('input[name=payment_agreements_percent_4]').val()) / 100;
        }
        
        $('input[name=payment_agreements_value]').val(pay_1);
        $('input[name=payment_agreements_value_2]').val(pay_2);
        $('input[name=payment_agreements_value_3]').val(pay_3);
        $('input[name=payment_agreements_value_4]').val(pay_4);
        },1000);
    }
});